import React, { useState } from 'react'
import { range } from 'ramda'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles';
import StartTime from './chooseTime'
import Card from './card'

const styles = theme => ({
    root: {
        padding:  '20px',
    },
    secondaryPaper: {
        padding:  '20px',
        marginTop: '20px'
    },
    radioBtn: {
        marginTop: '20px'
    }
})

const Weekly = (props) => {
    const [value] = useState(props.value)

    const onAtHourChange = (e) => {
        let val = value;
        val[1] = `${e.target.value}`;
        props.onChange(val)
    }
    const onAtMinuteChange = (e) => {
        let val = value;
        val[0] = `${e.target.value}`;
        props.onChange(val)
    }

    const onCheck = (e) => {
        let val = value;
        if (e.target.checked) {
            val[1] = (`${val[1]}`.split('/').length > 1) ? '0' : val[1].toString();
            val[3] = '*';
            if (val[4] === '*' || val[4] === 'MON-FRI') {
                val[4] = e.target.value;
            } else {
                val[4] = val[4] + '!' + e.target.value;
            }
        } else {
            val[4] = val[4] .split('!');
            if (val[4] .length > 1) {
                val[4] .splice(val[4] .indexOf(e.target.value), 1)
                val[4] = val[4] .toString().replace(/,/g, '!')
            } else {
                val[4] = '*';
            }
        }

        props.onChange(val)
    }

    const classes = props
    return (
        <div>
            <Paper className={classes.root}>
                <Grid container justify="space-evenly">
                    <Grid item justify="flex-start">
                        <Checkbox color="primary" type="checkbox" value="MON" onChange={onCheck} checked={(value[4].search('MON') !== -1) ? true : false} />&nbsp;Monday<br />
                        <Checkbox color="primary" type="checkbox" value="WED" onChange={onCheck} checked={value[4].search('WED') !== -1 ? true : false} />&nbsp;Wednesday<br />
                        <Checkbox color="primary" type="checkbox" value="FRI" onChange={onCheck} checked={(value[4].search('FRI') !== -1) ? true : false} />&nbsp;Friday<br />
                        <Checkbox color="primary" type="checkbox" value="SUN" onChange={onCheck} checked={value[4].search('SUN') !== -1 ? true : false} />&nbsp;Sunday
                    </Grid>
                    <Grid item justify="flex-start">
                        <Checkbox color="primary" type="checkbox" value="TUE" onChange={onCheck} checked={value[4].search('TUE') !== -1 ? true : false} />&nbsp;Tuesday<br />
                        <Checkbox color="primary" type="checkbox" value="THU" onChange={onCheck} checked={value[4].search('THU') !== -1 ? true : false} />&nbsp;Thursday<br />
                        <Checkbox color="primary" type="checkbox" value="SAT" onChange={onCheck} checked={value[4].search('SAT') !== -1 ? true : false} />&nbsp;Saturday
                    <br /><br />
                    </Grid>
                </Grid>
            </Paper>
        
            <Card label="Start time">
                <StartTime hour={value[1]} minute={value[0]} onAtMinuteChange={onAtMinuteChange} onAtHourChange={onAtHourChange} />
            </Card>
        </div>)
}

export default  withStyles(styles)(Weekly)
